import { render, staticRenderFns } from "./CarouselBanner.vue?vue&type=template&id=6721b67a"
import script from "./CarouselBanner.vue?vue&type=script&lang=js"
export * from "./CarouselBanner.vue?vue&type=script&lang=js"
import style0 from "./CarouselBanner.vue?vue&type=style&index=0&id=6721b67a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports